if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantInput = this.variantIdInput;
        if (variantInput) variantInput.disabled = false;

        this.submitButton = this.querySelector('[type="submit"]') || null;
        this.submitButtonText = this.submitButton?.querySelector('span') || null;
        this.spinnerEl = this.querySelector('.loading__spinner') || null;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // ✅ Listen for variant:change events from within the same product section
        const sectionId = this.dataset.sectionId;
        const sectionEl = document.querySelector(`#shopify-section-${sectionId}`) || document;
        sectionEl.addEventListener('variant:change', (e) => this.onVariantChange(e));

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      /**
       * Called when the variant changes
       */
      onVariantChange(e) {
        const variant = e.detail?.variant;
        if (!variant || !this.submitButtonText) return;

        // --- Price On Request logic ---
        if (variant.available && variant.price === 0) {
          this.submitButtonText.textContent = 'Price On Request';
          this.submitButton?.removeAttribute('disabled');
          this.submitButton?.setAttribute('data-por-url', '/pages/contact-us');
          return;
        }

        // --- Default Dawn button behavior ---
        if (!variant.available) {
          this.submitButtonText.textContent = window.variantStrings.soldOut || 'Sold out';
          this.submitButton?.setAttribute('disabled', 'disabled');
          this.submitButton?.removeAttribute('data-por-url');
        } else {
          this.submitButtonText.textContent = window.variantStrings.addToCart || 'Add to cart';
          this.submitButton?.removeAttribute('disabled');
          this.submitButton?.removeAttribute('data-por-url');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const btn = this.submitButton;
        const porUrl = btn?.dataset?.porUrl;

        // ✅ If POR mode, navigate instead of adding to cart
        if (porUrl) {
          window.location.href = porUrl;
          return;
        }

        if (btn && btn.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (btn) {
          btn.setAttribute('aria-disabled', true);
          btn.classList.add('loading');
        }
        if (this.spinnerEl) this.spinnerEl.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = btn?.querySelector('.sold-out-message');
              if (!soldOutMessage || !btn) return;
              btn.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            if (btn) {
              btn.classList.remove('loading');
              if (!this.error) btn.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (this.spinnerEl) this.spinnerEl.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText)
            this.submitButtonText.textContent = window.variantStrings.addToCart || 'Add to cart';
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]') || null;
      }
    }
  );
}
